var _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1024_2933",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1024_2933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 20.75C8.3375 20.75 7.98438 20.6031 7.69063 20.3094C7.39688 20.0156 7.25 19.6625 7.25 19.25V8.75C7.25 8.3375 7.39688 7.98438 7.69063 7.69063C7.98438 7.39688 8.3375 7.25 8.75 7.25H13.25V8.75H8.75V19.25H19.25V14.75H20.75V19.25C20.75 19.6625 20.6031 20.0156 20.3094 20.3094C20.0156 20.6031 19.6625 20.75 19.25 20.75H8.75ZM17 13.25V11H14.75V9.5H17V7.25H18.5V9.5H20.75V11H18.5V13.25H17Z",
    fill: "black"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskUpload);
export default __webpack_public_path__ + "static/media/taskUpload.b51ae1ac28b8b28090415c4f757ac12b.svg";
export { ForwardRef as ReactComponent };